import React, { useEffect, useRef, useState } from "react";
import cx from "classnames";
import { defineMessages, useIntl } from "react-intl";
import { shortcuts as config } from "config";
import Application from "./application";
import Content from "./content";
import Media from "./media";
import Modal from "./modal";
// import BottomBar from "components/bars/bottom";
// import TopBar from "components/bars/top";
import { play, seek, skip } from "utils/actions";
import { ID } from "utils/constants";
import layout from "utils/layout";
import player from "utils/player";
import Shortcuts from "utils/shortcuts";
import storage from "utils/data/storage";
import { useCurrentIndex } from "components/utils/hooks";
import StickerModal from "components/modals/sticker";
import "./index.scss";
import VideoWebcams from "./videoWebcams";

const intlMessages = defineMessages({
  aria: {
    id: "player.wrapper.aria",
    description: "Aria label for the player wrapper",
  },
});

const DEF_STICKER_ALL_USERS = 20;
const SEND_STICKER = "send_sticker";
const SEND_STICKER_ALL_USERS = "send_sticker_all_users";

const Player = () => {
  const intl = useIntl();
  const currentIndex = useCurrentIndex(storage.messages);

  const [fullscreen, setFullscreen] = useState(false);
  const [modal, setModal] = useState("");
  const [search, setSearch] = useState([]);
  const [section, setSection] = useState(layout.section);
  const [swap, setSwap] = useState(layout.swap);
  const [sticker, setSticker] = useState({});
  const [show, setShow] = useState();

  const shortcuts = useRef();

  useEffect(() => {
    const { seconds } = config.seek;

    const actions = {
      fullscreen: () => setFullscreen((prevFullscreen) => !prevFullscreen),
      play: () => play(),
      section: () => setSection((prevSection) => !prevSection),
      seek: {
        backward: () => seek(-seconds),
        forward: () => seek(+seconds),
      },
      skip: {
        next: () => skip(+1),
        previous: () => skip(-1),
      },
      swap: () => setSwap((prevSwap) => !prevSwap),
    };

    shortcuts.current = new Shortcuts(actions);

    return () => {
      if (shortcuts.current) shortcuts.current.destroy();
    };
  }, []);

  useEffect(() => {
    if (currentIndex < 0) return setSticker({});
    let _stickerUser = {};
    const currentTime = player.webcams.currentTime();

    // Show sticker animation
    const userInfo = storage?.data?.events?.userInfo || [];
    const listStudent = userInfo?.filter((user) => user?.isStudent);
    const currentMessage = storage.messages[currentIndex] || "";
    const messagesActiveSplit = currentMessage?.message?.trim()?.split("|");
    if (
      listStudent?.length === 1 &&
      currentTime <= currentMessage?.timestamp + 3 &&
      messagesActiveSplit?.[0] === SEND_STICKER &&
      !show
    ) {
      const sticker = messagesActiveSplit?.[2];
      setShow(+sticker);
    }

    // Handle sticker in webcam
    const _messages =
      storage.messages
        ?.filter(
          (item, index) =>
            currentIndex >= index &&
            !!item?.message &&
            item?.message?.includes(SEND_STICKER)
        )
        ?.map((item) => item?.message) || [];

    if (_messages?.length === 0) return setSticker({});

    for (const key in _messages) {
      if (_messages.hasOwnProperty(key)) {
        const message = _messages[key];
        const messageSplit = message?.trim()?.split("|");
        if (messageSplit?.[0] === SEND_STICKER) {
          // handle sticker all user
          if (messageSplit?.[1] === SEND_STICKER_ALL_USERS) {
            return listStudent?.forEach((user) => {
              if (!!_stickerUser?.[user?.userId]?.count) {
                _stickerUser[user?.userId] = {
                  count: _stickerUser[user?.userId]?.count + 1,
                  stickerImg: _stickerUser[user?.userId]?.stickerImg,
                };
              } else {
                _stickerUser[user?.userId] = {
                  count: 1,
                  stickerImg: DEF_STICKER_ALL_USERS,
                };
              }
            });
          }
          // handle sticker 1 user
          if (!!_stickerUser?.[messageSplit?.[1]]?.count) {
            _stickerUser[messageSplit?.[1]] = {
              count: _stickerUser?.[messageSplit?.[1]]?.count + 1,
              stickerImg:
                +messageSplit?.[2] ||
                _stickerUser[messageSplit?.[1]]?.stickerImg,
            };
          } else {
            _stickerUser[messageSplit?.[1]] = {
              count: 1,
              stickerImg: +messageSplit?.[2] || 1,
            };
          }
        }
      }
    }

    setSticker(_stickerUser);
  }, [currentIndex]);

  const style = {
    "fullscreen-content": fullscreen,
    "hidden-section": !section,
    "single-content": layout.single,
  };

  return (
    <div
      aria-label={intl.formatMessage(intlMessages.aria)}
      // className={cx('player-wrapper', style)}
      id={ID.PLAYER}
      className={cx("new-player-wrapper", style)}
    >
      {/* <TopBar
        openModal={(type) => setModal(type)}
        section={section}
        toggleSection={() => setSection(prevSection => !prevSection)}
        toggleSwap={() => setSwap(prevSwap => !prevSwap)}
      /> */}
      <Media
        fullscreen={fullscreen}
        swap={swap}
        toggleFullscreen={() =>
          setFullscreen((prevFullscreen) => !prevFullscreen)
        }
      />
      <VideoWebcams sticker={sticker} />
      <Application openModal={(type) => setModal(type)} />
      <Content
        fullscreen={fullscreen}
        handleSearch={(value) => setSearch(value)}
        search={search}
        swap={swap}
        toggleFullscreen={() =>
          setFullscreen((prevFullscreen) => !prevFullscreen)
        }
      />
      {/* <BottomBar /> */}
      <Modal
        handleClose={() => setModal("")}
        handleSearch={(value) => setSearch(value)}
        modal={modal}
      />
      {!!show && <StickerModal sticker={show} onClose={() => setShow()} />}
    </div>
  );
};

export default Player;
